// extracted by mini-css-extract-plugin
module.exports = {"deactivatedLabel":"RNo09"};